var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('v-header'),_c('mode-nav',{attrs:{"mode":_vm.mode}}),(_vm.isValidContext)?_c('router-view'):_c('landing')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }